<template>

	<div class="pdp-default-v1">
		<h2 class="header">
			<span class="pdpTitle">{{ content.pdpTitle }}</span>
			<button v-if="!isXRayEnabled" ref="pdpWindow" :aria-label="content.pdpClose" class="close-btn" tabindex="0" @click="closePdp" @keydown.esc="closePdp">
				<img alt="Close" src="/images/icon-close-white.svg"/>
			</button>
		</h2>

		<div ref="toastContent" class="content">
			<div :class="`content-container ${flyerOrientation}`">
				<div class="pdpContainer">
					<span v-if="config.showProductName !== undefined && config.showProductName">
                        <h2 v-if="productName" tabindex="0"> {{ productName }} </h2>
					</span>

					<div :class="{productImageContainer:checkClient}">
						<image-magnifier
								:alt-text="productName || 'Product image'"
								:image-src="productImage"
						/>
					</div>
					<div class="price" tabindex="0">
						<h2>
							<span v-if="priceQty">{{ priceQty }}/</span>

							<span v-if="pricePrefix"> {{ pricePrefix }} </span>

							<span v-if="!isBogo && salePrice"> {{ salePrice }}</span>
							<span v-if="!isBogo && promoUnit && salePrice"> {{ promoUnit }}  </span>

							<span v-if="alternatePrice" class="alternatePrice">{{ alternatePrice }}</span>
						</h2>
						<span v-if="!isBogo && !isSwipeAndSave && isXDaySale && limitQty" class="limit"> &nbsp;{{ limitQty }}</span>
					</div>

					<div v-if="savings" :class="{limit: isBogo}" class="savings">
						<h2>
							{{ savingsPrefix }}
							{{ savings }}
							{{ savingsSuffix }}
						</h2>
					</div>

					<div v-if="showTierEachPrice" class="daysOnly">
						{{ tierEachPrice }}
					</div>

					<div class="validity">
						<span><strong>{{ content.pdpValidFrom }}</strong></span>
						<div class="date" v-html="flyerDate"></div>
					</div>

					<div v-if="checkClient && (description || productName)" class="detail">
						<span>{{ content.pdpDetails }}</span>
						<p class="detail-content" v-html="description || productName"/>
					</div>
					<div v-else-if="!checkClient && description" class="detail">
						<span>{{ content.pdpDetails }}</span>
						<p class="detail-content" v-html="description"/>
					</div>

					<p class="disclaimer-content">{{ content.disclaimer }}</p>

					<div class="addtoList-container">
				<button v-if="!isXRayEnabled && checkProductInSL(product)"
				        class="shopOptions removeFromList"
				        tabindex="0"
				        @click="handleRemoveFromList(product)"
				>
					{{ content.pdpRemoveFromList }}
				</button>

				<button v-else-if="!isXRayEnabled && listEnabled"
				        class="shopOptions pdpAddToList"
				        tabindex="0"
				        @click="handleAddToList(product)"
				>
					{{ content.pdpAddToList }}
				</button>


				<button v-if="!isXRayEnabled && config.shopNow && !isBogo && !isSwipeAndSave && product.url" class="shopOptions shopNow" tabindex="0" @click="gotoInstaCart()">Shop Now</button>
					</div>

				</div>
			</div>
		</div>
	</div>

</template>

<script>

import {mapActions, mapGetters, mapState} from "vuex";
import moment from "moment";
import featureMixin from "@/mixins/featureMixin";
import AppConfig from "@/classes/AppConfig";
import pdpProductMixin from "@/features/pdp/PdpProductMixin";
import Lytics from "../../../classes/Lytics";

export default {

	mixins: [featureMixin, pdpProductMixin],

	data() {
		return {
			toastContent: null,
			ready: false,
			featurePath: 'pdp',
			featureEvents: ['productRegionClick']
		};
	},
	mounted() {
		this.ready = true;
		this.$refs.pdpWindow.focus();
		// console.log(this.$refs.pdpPopup);
		/*if(this.enabled){
						const pdpFocus = this.$refs.pdpPopup;
						pdpFocus.focus();
					}*/

	},
	computed: {
		...mapState(['currentPageNumber']),
		...mapGetters(["content", "language", "dealId", "isXRayEnabled"]),
		...mapGetters("screen", ["flyerOrientation"]),
		...mapGetters("landingPage", ["currentFlyer"]),
		...mapState("shoppingList", ["shoppingListV1"]),
		...mapGetters("pdp", {pdpEnabled: "enabled"}),
		...mapState("pdp", {showPdp: "isVisible"}),
		...mapGetters('shoppingList', {listEnabled: 'enabled'}),

		priceQty() {
			if(!this.isXDaySale) return '';
			return pdpProductMixin.computed.priceQty.call(this);
		},

		checkClient() {
			return !!AppConfig.AppConf?.title.toLowerCase().includes("rexall".toLowerCase());
		},

		isBogo() {
			return this.product?.tags?.includes('bogo')
		},

		isSwipeAndSave() {
			if (this.product === null) return;
			if (this.dealId === 'PP4123' && (this.product.sku === '61328852856' || this.product.sku === '30772072509')) return true
			return this.product.tags?.includes('S&S');
		},

		flyerDate() {
			if (this.product === null) return;
			let startDate, endDate;
			if (this.isSwipeAndSave) {
				startDate = this.validFromFlyer;// moment(this.currentFlyer.startDate)
				endDate = this.validToFlyer;// moment(this.currentFlyer.endDate)
			} else if (this.isXDaySale) {
				startDate = moment(this.product.validFrom);
				endDate = moment(this.product.validTo)
			} else {
				if (this.product.validFromROW !== null) {
					startDate = moment(this.product.validFromROW)
					endDate = moment(this.product.validToROW)
				} else {
					startDate = moment(this.product.validFrom);
					endDate = moment(this.product.validTo)
				}
			}

			if (this.language === 'en') {
				return `${(startDate).locale(this.language).format('MMMM D, YYYY')} to ${(endDate).locale(this.language).format('MMMM D, YYYY')}`
			} else {
				return `${startDate.format('D MMMM, YYYY').replace('1er', '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')} jusqu'au ${endDate.format('D MMMM, YYYY').replace('1er', '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')}`;
			}

		},

		salePrice(){
			return this.getSalePrice || pdpProductMixin.computed.salePrice.call(this);
		},


		getSalePrice() {
			if (this.product === null) return
			let price
			const date = this.currentDate;// router.currentRoute.query['timeTravelDate'] ?? moment();
			//subtracting and adding 1 day because isBetween function from momentJS doesn't consider the actual date (same day)
			const startDate = this.validFromRow;// moment(this.product.validFromROW).subtract(1, "days")
			const endDate = this.validToRow;// moment(this.product.validToROW).add(1, "days")
			if (this.isSwipeAndSave) {
				if (this.product?.savingsEn) {
					price = this.product.savingsPrefix + ' ' + this.product.savingsEn
					return price
				} else {
					price = this.product.salePrice
				}
			} else if (this.isXDaySale)
				price = this.product?.salePrice
			else if (this.product.rowPrice && moment(date).isBetween(startDate, endDate))
				price = this.product?.rowPrice;
			else
				price = this.product?.rowPrice;

			if (price == null)
				return ''


			else {
				if (this.product?.savingsEn) {
					price = this.product.savingsPrefix + ' ' + this.product.savingsEn
					return price
				} else {
					if (price.trim() !== '') {
						// do nothing to test
					} else {
						price = this.product.salePrice;

					}

				}
			}
			return this.product?.priceSign?.includes('$') ? `${this.product.priceSign}${(price)} ` : `${price}${this.product.priceSign}`;
		},

		getContents() {
			return this.product?.contents
		},

		columnView() {
			return this.flyerOrientation === "vertical";
		},

		enabled() {
			return this.pdpEnabled && this.config.mode === 'internal';
		}

	},

	methods: {
		...mapActions(["setPdpDisplay", "setCurrentProduct"]),
		...mapActions("shoppingList", ["setAddToList", "setRemoveFromList", "handleFlyerDate"]),
		...mapActions("pdp", ["close", "open"]),

		/*onFeatureEvent(event, data) {
			if (this.config.enabled) {
				// console.log('PDP Event:', data.product)
				if (this.config.mode === 'internal' && data.sku !== 'url' && !data.isVideo) {
					this.open(data.product);
				}
			}
		},*/

		closePdp() {
			if (this.ready) {
				this.close();
			}
		},
		handleAddToList(product) {
			// console.log("Handle add to list", product)
			const additionalItemFlag = false;
			const version = 'v1'
			this.handleFlyerDate(this.flyerDate)
			this.setAddToList({product, additionalItemFlag, version});

		},

		handleRemoveFromList(product) {
			const version = 'v1'
			this.setRemoveFromList({product, version});
		},

		checkProductInSL(product) {
			let item = this.shoppingListV1.filter(function (e) {
				return e.sku == product.sku;
			});
			if (item.length > 0) return true;
			else return false;
		},

		gotoInstaCart() {
			window.open(this.product.url)
			Lytics.TransferToMerchantClick({
				page_number: this.currentPageNumber,
				data: {...this.product}
			})
		}
	},

	watch: {
		ready(val) {
			if (val) {
				this.$nextTick(() => {
					const detailText = document.querySelector('.content .detail-content')
					if (detailText) {
						detailText.innerHTML = detailText.innerHTML
							.replace(/(\([^)]*\)|^)(\s*\*off reg\. price)(?=$|\s+select types\s+)\b/gi, '$1\n$2')
							.replace(/(\b|^)(select types\s*\*off reg\. price|selected types and sizes\s*\*off reg\. price|(\s*)(\*off reg\. price))(?=\s*$|\S)/gi, (match, p1, p2, p3, p4) => {
								return p2 ? p1 + '\n' + p2 : p4 ? p3 + '\n' + p4 : ''
							})
							.replace(/(\b|^)select types(?=\s*$)/gi, '\n$&')
							.replace(/(\b|^)selected types and sizes(?=\s*$)/gi, '\n$&')
							.replace(/&amp;/g, "&")
							.replace(/(\b|^)(rest of week?\s*(&|,)?\s*)?(after limit)/gi, (match, p1, p2, p3, p4) => {
								return (p2 && p4) ? p1 + p2 + p4 : '\n' + p4;
							})
					}
				})
			}

		},
	},
};
</script>

<style lang="scss" scoped>

.modal-wpr {
  position: absolute;
  margin-top: -1px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 20;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-flow: column;

  .modal {
	background-color: var(--secondary-color);
	/*margin-top: 75px;*/
	border: 1px solid #bbbbbb;
	/* overflow: auto;*/
	max-height: calc(100% - 1em);
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	display: flex;
	flex-flow: column;
	min-width: 300px;
	max-width: 370px;


	.header {
	  background-color: var(--secondary-color);
	  color: var(--primary-text-color);
	  display: flex;
	  justify-content: space-between;
	  padding: 10px;

	  h2 {
		font-size: 1.3em;
		text-transform: uppercase;
		font-weight: 400;
	  }

	  .close-btn {
		cursor: pointer;

		&:hover {
		  background: none;
		  filter: unset;
		}
	  }
	}

	.subtitle {
	  padding-top: 6px;
	  font-size: 12px;
	}

	.content {
	  padding: 8px;
	  background-color: #fff;
	  color: #545454;
	  position: relative;
	  flex: 1 0 auto;
	  overflow: auto;
	  font-size: 0.9em;
	  margin: 10px 10px 17px;
	  min-height: 250px;
	  max-height: calc(100% - 4em);

	  .content-container {
		text-align: left;
		//width:300px;
	  }

	  .f-half {
		display: flex;
		column-gap: 1em;

		flex-direction: column;

		> div {
		  flex-basis: 100%;
		  display: flex;
		  flex-flow: column;
		}
	  }
	}
  }
}

.pdpTitle {
  font-size: 0.9em;
  font-weight: bold;
}

.pdpContainer {
  //margin-left: 10px;
  max-width: calc(100vw - 5em);

  h2 {
	font-size: 18px;
  }

  .productImageContainer {
	background-color: #eee;
	padding: 5px 0;
	margin-bottom: 10px;
	border: 1px solid darkgray;
	display: flex;
	justify-content: center;
  }

  .productImage {
	// max-height: 60%;
	// max-width: 60%;
	display: flex;
	max-height: 200px;
	max-width: 120px;
  }

  .price {
	display: flex;
	color: #ee3124;
  }

  span.alternatePrice {
	display: inline-block;
  }

  .alternatePrice {
	color: #000;
	font-size: 13px;
	font-weight: normal;
	margin-left: 5px;
  }

  .savings {
	color: #ee3124 !important;
	font-size: 18px;
	margin-top: 5px;
  }

  .limit {
	font-weight: 900;
	color: #000;
	font-size: 1.2em;
  }

  .detail {
	margin-top: 10px;
	font-weight: 900;

	.detail-content {
	  font-size: 12px;
	  font-weight: normal;
	  white-space: break-spaces;
	}
  }

  .disclaimer-content {
	font-size: 9px;
	font-weight: normal;
	margin-top: 10px;
	font-style: italic;
  }

  .daysOnly {
	margin-top: 10px;
	font-size: 1.1em;
	font-weight: 900;
  }

  & .validity {
	margin-top: 10px;
  }
}

button {
  background: transparent;
  // border: 1px solid #ccc;
  text-transform: uppercase;
  font-weight: 600;
  color: #666;
  border-radius: 4px;
  border: none;
}

button.button {
  background: #fff;
  border: 1px solid #ccc;
  text-transform: uppercase;
  font-weight: 600;
  color: #666;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 16px;
}

button.button:hover {
  background: #eee;
  color: #000;
}

.btn {
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 4px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  color: #333;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  cursor: auto;
  pointer-events: none;
}

.addtoList-container {
  display: flex;
}

.shopOptions {
  display: flex;
  flex: 1;
  cursor: pointer;
  border-radius: 5px;
  margin: 10px 5px;
  color: #fff;
  padding: 8px;
  justify-content: center;
  font-weight: normal;
  height: 55px;

  &.shopNow {
	background-color: var(--secondary-color);
  }

  &.pdpAddToList {
	background-color: var(--tertiary-color);
  }

  &.removeFromList {
	background-color: #EE3124;
  }
}

/* width */
::-webkit-scrollbar {
  width: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  //background: #f1f1f1;
  display: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.btn.page {
  width: 100%;
  height: 28px;
  justify-content: flex-start;
  padding-left: 3%;
  margin-bottom: 8px;

  & + .subtitle {
	text-align: left !important;
  }
}

.page-num {
  background-color: var(--primary-color);
  color: var(--primary-text-color);
  border-radius: 4px;
  font-size: 12px;
  padding: 7px;
}

@media only screen and (max-height: 850px) and (min-width: 1024px) {
  .modal-wpr .modal {
	.content {
	  .f-half {
		flex-direction: row !important;
	  }

	  .content-container {
		width: 308px;

	  }
	}
  }
}


@media only screen and (max-width: 700px) {
  .modal-wpr .modal {
	.content {
	  .content-container {
		//width: 300px;
		.productImage {
		  // max-height: 50%;
		  // max-width: 50%;
		  max-height: 180px;
		  max-width: 85px;
		}
	  }
	}
  }
}

/* Vertical View Specific */
@media (min-width: 1200px) {
  .modal-wpr .modal.vertical .content .feature.navigation {

	h4,
	.subtitle {
	  text-align: left;
	  width: 100%;
	}

	.subtitle + .subtitle {
	  margin-top: 1em;
	}
  }
  .content-container {
	width: 308px;
  }
}
</style>
